export function DecoShapes() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <span className="absolute -left-10 top-16 h-28 w-28 rounded-full bg-rosa/15" />
      <span className="absolute right-8 top-10 h-10 w-10 rotate-45 rounded-lg bg-rosa/20" />
      <span className="absolute bottom-12 left-1/3 h-5 w-5 rotate-45 bg-terracotta/40" />
      <span className="absolute bottom-16 right-1/4 h-14 w-14 rounded-full border-4 border-corn/50" />
      <span className="absolute bottom-24 left-10 h-3 w-3 rounded-full bg-talavera/30" />
    </div>
  );
}
